import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";

import { DatePicker } from "../../../../components/DatePicker";
import { UpdateBillingPaymentScheduleDate } from "../../../../types/billing";
import { BillingPaymentScheduleType, IBillingPaymentSchedule } from "../../../../types/billings";

import styles from "./BillingPaymentSchedulePicker.module.scss";

type IBillingPaymentSchedulePickerProps = {
  paymentSchedule: IBillingPaymentSchedule;
  paymentScheduleType: BillingPaymentScheduleType;
  onPaymentDateChange: (payload: UpdateBillingPaymentScheduleDate) => void;
  isDisabled?: boolean;
};

export const BillingPaymentSchedulePicker = ({
  isDisabled,
  paymentSchedule,
  paymentScheduleType,
  onPaymentDateChange,
}: IBillingPaymentSchedulePickerProps) => {
  const { t } = useTranslation();

  dayjs.extend(quarterOfYear);

  if (paymentScheduleType === BillingPaymentScheduleType.Annual) {
    return (
      <div className={styles.container}>
        <DatePicker
          onChange={(date) => onPaymentDateChange({ field: "annualDueDate", value: date.toISOString() })}
          value={new Date(paymentSchedule.annualDueDate)}
          minDate={dayjs(paymentSchedule.annualDueDate).startOf("year")}
          maxDate={dayjs(paymentSchedule.annualDueDate).endOf("year")}
          withIcon
          label={t("billingPaymentSchedulePicker.annualDueDate")}
          isDisabled={isDisabled}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <DatePicker
        onChange={(date) => onPaymentDateChange({ field: "q1DueDate", value: date.toISOString() })}
        value={new Date(paymentSchedule.q1DueDate)}
        minDate={dayjs(paymentSchedule.q1DueDate).startOf("quarter")}
        maxDate={dayjs(paymentSchedule.q1DueDate).endOf("quarter")}
        withIcon
        label={t("billingPaymentSchedulePicker.dueToQ1")}
        isDisabled={isDisabled}
      />
      <DatePicker
        onChange={(date) => onPaymentDateChange({ field: "q2DueDate", value: date.toISOString() })}
        value={new Date(paymentSchedule.q2DueDate)}
        minDate={dayjs(paymentSchedule.q2DueDate).startOf("quarter")}
        maxDate={dayjs(paymentSchedule.q2DueDate).endOf("quarter")}
        withIcon
        label={t("billingPaymentSchedulePicker.dueToQ2")}
        isDisabled={isDisabled}
      />
      <DatePicker
        onChange={(date) => onPaymentDateChange({ field: "q3DueDate", value: date.toISOString() })}
        value={new Date(paymentSchedule.q3DueDate)}
        minDate={dayjs(paymentSchedule.q3DueDate).startOf("quarter")}
        maxDate={dayjs(paymentSchedule.q3DueDate).endOf("quarter")}
        withIcon
        label={t("billingPaymentSchedulePicker.dueToQ3")}
        isDisabled={isDisabled}
      />
      <DatePicker
        onChange={(date) => onPaymentDateChange({ field: "q4DueDate", value: date.toISOString() })}
        value={new Date(paymentSchedule.q4DueDate)}
        minDate={dayjs(paymentSchedule.q4DueDate).startOf("quarter")}
        maxDate={dayjs(paymentSchedule.q4DueDate).endOf("quarter")}
        withIcon
        label={t("billingPaymentSchedulePicker.dueToQ4")}
        isDisabled={isDisabled}
      />
    </div>
  );
};
